import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { Observable } from 'rxjs';
import { AuthenticationService } from '@shared/authentication/data-access';
import { map } from 'rxjs/internal/operators/map';
import { catchError } from 'rxjs/operators';

@Injectable()
export class AuthResolveGuard  {

	constructor(
		@Inject(PLATFORM_ID) protected platformId: any,
		private readonly authService: AuthenticationService
	) { }

	public resolve(): Observable<any> {
		return this.authService.getIsAuthenticated$().pipe(map((loggedIn: boolean) => loggedIn), catchError<boolean, any>(() => false));
	}
}
